export default __webpack_public_path__ + "static/media/no_subscribed_feeds.02439e6c.svg";